import { createFileRoute } from "@tanstack/react-router";
import { Box, Spinner } from "@salestrak/ui";
import { useApiKeys, useApiKeyMutations } from "#app/hooks/settings/use-api-key-mutations";
import { ApiKeyFormView } from "#app/components/settings/api-key-form-view";
import type { Permissions } from "#app/components/settings/permission-badge";
import { useAppNavigate } from "#app/lib/hooks/use-app-navigate";
import { withPermission } from "#app/components/permissions/require-permission";

function ApiKeyEditPage() {
  const { apiKeyId } = Route.useParams();
  const { replace } = useAppNavigate();
  const { apiKeys, isLoading } = useApiKeys();
  const { updateApiKey } = useApiKeyMutations();

  const apiKey = apiKeys.find((k: any) => k.apiKeyId === apiKeyId);

  if (isLoading && !apiKey) {
    return (
      <Box fill="flex" align="center" justify="center">
        <Spinner />
      </Box>
    );
  }

  if (!apiKey) {
    replace("/settings/api");
    return null;
  }

  async function handleSubmit(data: { name: string; permissions: Permissions }) {
    const { __typename, ...cleanPerms } = data.permissions as any;

    await updateApiKey(apiKeyId, {
      name: data.name,
      permissions: cleanPerms,
    });
    replace(`/settings/api/keys/${apiKeyId}`);
  }

  return (
    <ApiKeyFormView
      apiKey={{
        apiKeyId: apiKey.apiKeyId,
        name: apiKey.name,
        permissions: apiKey.permissions,
      }}
      onCancel={() => replace(`/settings/api/keys/${apiKeyId}`)}
      onSubmit={handleSubmit}
    />
  );
}

export const Route = createFileRoute(
  "/(app)/$workspace/settings/api/keys/$apiKeyId/edit",
)({ component: withPermission("workspace.integrations", ApiKeyEditPage) });
